import './styles.scss'

export default function BatteryPercentage({ batteryPercentage }) {
  if (batteryPercentage == null || batteryPercentage < 0 || batteryPercentage > 100) return <></>

  return (
    <div className='battery-percentage-comp row'>
      <i className={`material-icons ${getBatteryStyle(batteryPercentage)}`}>{getBatteryIcon(batteryPercentage)}</i>
      <p className='subtitle'>{`${batteryPercentage}%`}</p>
    </div>
  )
}

function getBatteryIcon(percentage) {
  if (percentage <= 5) return 'battery_0_bar'
  if (percentage <= 20) return 'battery_1_bar'
  if (percentage <= 35) return 'battery_2_bar'
  if (percentage <= 50) return 'battery_3_bar'
  if (percentage <= 65) return 'battery_4_bar'
  if (percentage <= 80) return 'battery_5_bar'
  if (percentage <= 94) return 'battery_6_bar'
  return 'battery_full'
}

function getBatteryStyle(percentage) {
  if (percentage >= 0 && percentage <= 20) return 'critical'
  if (percentage > 20 && percentage <= 35) return 'low'
  if (percentage > 35) return 'high'
  return 'default'
}
